import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js";

export default class extends Controller {
  connect() {
    let data = {
      labels: ["Bad", "Also bad", "Good", "Better", "Best"],
      datasets: [{
        data: [20, 20, 20, 20, 20],
        backgroundColor: ["#4ec3bf", "#023838", "#f178af", "#d3df5e", "green"],
        cutout: "80%",
        circumference: 180,
        rotation: 270
      }]
    }
    let config = {
      type: "pie",
      data: data,
      options: {
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
          datalabels: { display: false }
        },
      }
    }

    new Chart(this.element, config)
  }
}
